import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import CreationToolRating from '../../../types/rating'
import CreationToolUploadField from '../../../types/upload-field'
import { UploadFieldBlock } from '../../blocks'
import SegmentedControl from '../../segmented-control'
import Instructions from '../field-instructions'
import Title from '../field-title'
import { CreationToolUploadContext } from '../manager'

const Container = styled(UploadFieldBlock as any)`
    grid-column: span 4;
`

type Props = {
    className?: string
    field: CreationToolUploadField
}

const CreationUploadRatingField = ({ className, field }: Props) => {
    const { setRating } = useContext(CreationToolUploadContext)
    const [activeIndex, setActiveIndex] = useState<number>(0)
    const ratings = CreationToolRating.all()

    useEffect(() => {
        const rating = ratings[activeIndex]
        setRating(CreationToolRating.value(rating))
    }, [activeIndex])

    return (
        <Container className={className}>
            <Title field={field} />
            <SegmentedControl items={ratings.map(CreationToolRating.title)} onIndexChange={setActiveIndex} />
            <Instructions field={field} />
        </Container>
    )
}

export default CreationUploadRatingField
